import axios from "axios";
import { getToken } from "../../Utlis/UpdateUserState";

const getVendorTransactionAdjustments = async (startDate, endDate) => {
  try {
    const token = getToken();

    const params = new URLSearchParams();
    if (startDate) params.append("start_date", startDate);
    if (endDate) params.append("end_date", endDate);

    const query = params.toString();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}fuel-vendor/transaction-adjustments/${query ? `?${query}` : ""}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fuel vendor transaction adjustments fetch error:", error);
    throw error;
  }
};

const getVendorAdjustableTransactions = async () => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}fuel-vendor/transaction-adjustments/lookup/`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Adjustable transactions fetch error:", error);
    throw error;
  }
};

const getFuelBrands = async () => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}fuel-vendor/transaction-adjustments/fuel-brands/`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fuel brands fetch error:", error);
    throw error;
  }
};

const getAdjustmentById = async (id) => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}fuel-vendor/transaction-adjustments/?id=${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Transaction adjustment detail fetch error:", error);
    throw error;
  }
};

const submitTransactionAdjustment = async (formData) => {
  try {
    const token = getToken();

    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}fuel-vendor/transaction-adjustments/`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      },
    );

    return res;
  } catch (error) {
    console.error("Transaction adjustment submit error:", error);
    throw error;
  }
};

export {
  getVendorTransactionAdjustments,
  getVendorAdjustableTransactions,
  getFuelBrands,
  getAdjustmentById,
  submitTransactionAdjustment,
};
